<template>
    <div class="container-fluid container-videos" v-if="grande">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="container-title container-title--white">
                        <p>Vídeos</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6" v-if="grande">
                    <router-link :to="grande.url" target="_self" class="noticies-item">
                        <div class="noticies-item--image">
                            <img v-if="grande.video && grande.video.thumbnail" :src="utils.image(grande.video.thumbnail, 544, 368)" alt="">
                        </div>
                        <div class="noticies-item--info">
                            <p class="noticies__title noticies__title--white"><strong>{{grande.title}}</strong></p>
                        </div>
                        <div class="noticies-item__play"></div>
                    </router-link>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-lg-6" v-for="video in pequenos1" :key="video.id">
                            <router-link :to="video.url" target="_self" class="noticies-item">
                                <div class="noticies-item--image">
                                    <img v-if="video.video && video.video.thumbnail" :src="utils.image(video.video.thumbnail, 256, 168)" alt="">
                                </div>
                                <div class="noticies-item--info">
                                    <p class="noticies__title noticies__title--small noticies__title--white">
                                        <strong>{{video.title}}</strong>
                                    </p>
                                </div>
                                <div class="noticies-item__play noticies-item__play--small"></div>
                            </router-link>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6" v-for="video in pequenos2" :key="video.id">
                            <router-link :to="video.url" target="_self" class="noticies-item">
                                <div class="noticies-item--image">
                                    <img v-if="video.video.thumbnail" :src="utils.image(video.video.thumbnail, 256, 168)" alt="">
                                </div>
                                <div class="noticies-item--info">
                                    <p class="noticies__title noticies__title--small noticies__title--white">
                                        <strong>{{video.title}}</strong>
                                    </p>
                                </div>
                                <div class="noticies-item__play noticies-item__play--small"></div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import utils from '@/utils'

export default {
    name: 'Videos',
    data: function() {
        return {
            grande: null,
            pequenos1: [],
            pequenos2: [],
            utils: utils,
        }
    },
    methods: {
        async getVideos() {
            const response = await api.get('pages/',{
                type: 'videos.VideoPage',
                fields: 'video,url',
                limit: 5,
                order: '-first_published_at'
            })
            if (response.ok) {
                this.grande = response.data.items[0]
                this.pequenos1 = response.data.items.slice(1,3)
                this.pequenos2 = response.data.items.slice(3,5)
            }
        }
    },
    mounted() {
        this.getVideos()
    }
}
</script>